import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUseCase, RequestStatus } from '@lib/plugin-redux-core';
import { GET_PROMPT_TEMPLATES_USE_CASE } from '../../../ai';
import { selectPromptTemplates, selectPromptTemplatesStatus } from '../redux/ai-chat/ai-chat.selectors';
export var usePromptTemplates = function usePromptTemplates(_ref) {
  var resourceType = _ref.resourceType,
      resourceId = _ref.resourceId,
      createdByType = _ref.createdByType;
  var dispatch = useDispatch();
  var promptTemplates = useSelector(selectPromptTemplates);
  var promptTemplatesStatus = useSelector(selectPromptTemplatesStatus);
  var getPromptTemplatesUseCase = getUseCase(GET_PROMPT_TEMPLATES_USE_CASE, dispatch);
  var resourceTypeRef = useRef(resourceType);
  var resourceIdRef = useRef(resourceId);
  var createdByTypeRef = useRef(createdByType);
  resourceTypeRef.current = resourceType;
  resourceIdRef.current = resourceId;
  createdByTypeRef.current = createdByType;
  useEffect(function () {
    if (!resourceType || !resourceId) {
      getPromptTemplatesUseCase.reset();
      return;
    }

    getPromptTemplatesUseCase.execute({
      resourceType: resourceType,
      resourceId: resourceId,
      createdByType: createdByType
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourceId, resourceType]);
  var retry = useCallback(function () {
    if (!resourceTypeRef.current || !resourceIdRef.current) return;
    getPromptTemplatesUseCase.execute({
      resourceType: resourceTypeRef.current,
      resourceId: resourceIdRef.current,
      createdByType: createdByTypeRef.current
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    promptTemplates: promptTemplates !== null && promptTemplates !== void 0 ? promptTemplates : [],
    isLoading: promptTemplatesStatus === RequestStatus.EXECUTE,
    isError: promptTemplatesStatus === RequestStatus.ERROR,
    retry: retry
  };
};